import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { Box, Typography, TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import "./ChannelDetail.css";
export const ChannelDetailForm = (props) => {
  const { channelName, setChannelName, user } = props;
  return (
    <Box className="Box23">
      <FormControl
        variant="standard"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "49%",
        }}
      >
        <TextField
          className="TextField"
          id="outlined-basic"
          label="User Name"
          variant="outlined"
          value={user?.value}
          sx={{ textTransform: "capitalize" }}
          InputLabelProps={{ shrink: channelName ? true : false }}
        />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>
          {user.error}
        </FormHelperText>
      </FormControl>
      <FormControl
        variant="standard"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "49%",
        }}
      >
        <TextField
          className="TextField"
          id="outlined-basic"
          label="Channel Name"
          variant="outlined"
          value={channelName?.value}
          InputLabelProps={{ shrink: channelName ? true : false }}
          onChange={(e) =>
            setChannelName({ ...channelName, value: e.target.value })
          }
        />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>
          {channelName.error}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};
